// src/components/PrivateRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Spinner from './Spinner';

const PrivateRoute = ({ element: Component }) => {
    const { isAuthenticated, isLoading } = useAuth();
    
    // Show loading spinner while checking authentication
    if (isLoading) {
        return (
            <div className="flex justify-center items-center min-h-screen">
                <Spinner />
            </div>
        );
    }
    
    // Redirect to login if not authenticated
    return isAuthenticated ? <Component /> : <Navigate to="/" />;
};

export default PrivateRoute;
